import "./english-interview-loading-result.scss";
import LOGO_INTERVIEW_AI from "../../assets/images/english-interview-logo.png";
import MASCOT_IMAGE from "../../assets/images/loading-mascot.png";
import MASCOT_SHADOW_IMAGE from "../../assets/images/shadow-mascot.png";
import MASCOT_TEXT_IMAGE from "../../assets/images/text-mascot.png";
import FOOTER_IMAGE from "../../assets/images/english-footer.png";

const EnglishInterviewLoadingResult = () => {
  return (
    <div className="english-interview-loading-result-control">
      <div className="english-interview-loading-result-content">
        <img
          src={LOGO_INTERVIEW_AI}
          className="english-interview-loading-logo"
          alt="English Interview AI Logo"
        />
        <div className="english-interview-mascot-section">
          <div className="english-interview-mascot-image-control">
            <img
              src={MASCOT_IMAGE}
              className="english-interview-mascot-image"
              alt=""
            />
            <img
              src={MASCOT_SHADOW_IMAGE}
              className="english-interview-mascot-shadow-image"
              alt=""
            />
          </div>
          <div className="english-interview-mascot-text-section">
            <img
              src={MASCOT_TEXT_IMAGE}
              className="english-interview-mascot-text-image"
              alt=""
            />
          </div>
        </div>
        <div className="english-interview-loading-loading-text-section">
          <span className="english-interview-loading-loading-text-title">
            กำลังวิเคราะห์คำตอบของคุณ...
          </span>
          <span className="english-interview-loading-loading-text-description">
            รออีกแป๊บเดียว <br />
            เราพร้อมให้คำแนะนำ <br />
            ช่วยให้คุณพูดได้มั่นใจยิ่งขึ้น
          </span>
        </div>
       
      </div>
      <div className="english-interview-loading-footer-section">
            <div className="english-interview-loading-footer-content">
                <span className="english-interview-loading-footer-text">
                อย่าพึ่งปิดหน้านี้นะ.. <br></br>
                รออีกนิดเท่านั้น
                </span>
            </div>
            <img src={FOOTER_IMAGE} className="english-interview-loading-footer-image" alt="" />
        </div>
    </div>
  );
};

export default EnglishInterviewLoadingResult;
